SupportFlexibleContactChannelsTemplate = require '../../../../flexible_contact_channels.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormIntlFlexibleContactChannelsView extends Backbone.View
  className: 'flexible-contact-channels-view'
  events:
    'DOMSubtreeModified .flex-primary-chat-button#live-chat-container' : 'handleDisplayOfPrimaryLiveChat'
    'DOMSubtreeModified .primary-chat-link#live-chat-link-container' : 'handleDisplayOfPrimaryLiveChatLink'
    'DOMSubtreeModified .secondary-chat-link#live-chat-link-container' : 'handleDisplayOfSecondaryLiveChatLink'
    'DOMSubtreeModified .tertiary-chat-link#live-chat-link-container' : 'handleDisplayOfTertiaryLiveChatLink'
    'click .flex-primary-email-button': 'renderEmailForm'
    'click .flex-primary-phone-button': 'renderPhoneView'
    'click .flex-email-link': 'renderEmailForm'
    'click .flex-phone-link': 'renderPhoneView'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportFlexibleContactChannelsTemplate
    @model = Groupon.Support.FlexibleContactChannelModel
    @mainView = @options.mainView

  render:() ->
    @model.presentContactChannels()
    @$el.empty()
    @$el.append toHtml(@template, @toHash({renderLayout:true, withoutChat: not @isLiveChatEnabled()}), @I18nScope)
    @handleDisplayOfChannelsWithMoreSpace()
    this

  isLiveChatEnabled: () ->
    Groupon.Support.LiveChatModel.isLiveChatEnabled()

  renderEmailForm: (e)->
    @mainView.renderEmailForm()

  renderPhoneView: ()->
    @mainView.renderPhoneNumberView()

  handleDisplayOfChannelsWithMoreSpace: ()->
    if window.evaluate(window.experiments.showFlexibleContactChannelsWithMoreSpace)
      @$el.addClass('flexible-contact-channels-view-with-more-space')
      @$el.find('.flex-primary-button').addClass('flex-primary-button-text-with-more-space')
      @$el.find('.flex-primary-chat-button').addClass('flex-primary-button-text-with-more-space')

  handleDisplayOfPrimaryLiveChat: ()->
    @$el.find('.flex-contact-channels-without-chat').empty()
    @setFlexibleLiveChatDisplayCallBack(@handleDisplayOfPrimaryLiveChat)
    if @flexiblePrimaryLiveChatVisible()
      window.showDOMElems $('.help-wizard-content > .flexible-contact-channels-container')
      window.hideDOMElems $('.flex-contact-channels-without-chat')
    else
      window.hideDOMElems $('.help-wizard-content > .flexible-contact-channels-container')
      window.showDOMElems $('.flex-contact-channels-without-chat')
      $('.flex-contact-channels-without-chat').append(toHtml(@template, @toHash({withoutChat: true}), @I18nScope))
      @handleDisplayOfChannelsWithMoreSpace()

  handleDisplayOfPrimaryLiveChatLink: ()->
    primaryChatTextElem = $(".flex-primary-channel-text")
    @toggleDomElemsBasedOnLiveChat primaryChatTextElem

  handleDisplayOfSecondaryLiveChatLink: ()->
    secondaryFlexibleLiveChatContainerElem = $('.secondary-flex-chat-channel')
    flexTertiaryOrTextElem = $('.flex-channel-or-text')
    DOMelemsToToggle = [secondaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]
    if @model.get('formattedContactChannels').contact_channels.length is 2 then DOMelemsToToggle.push $('.flex-secondary-channel-also-text')
    @toggleDomElemsBasedOnLiveChat DOMelemsToToggle

  handleDisplayOfTertiaryLiveChatLink: ()->
    tertiaryFlexibleLiveChatContainerElem = $('.tertiary-flex-chat-channel')
    flexTertiaryOrTextElem = $('.flex-channel-or-text')
    @toggleDomElemsBasedOnLiveChat [tertiaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]

  toggleDomElemsBasedOnLiveChat:(domElems)->
    if window.liveChatLinkVisible()
      window.showDOMElemsInline domElems
    else
      window.removeDOMElemsInline domElems
      window.hideDOMElems domElems

  setFlexibleLiveChatDisplayCallBack: (liveChatDisplayCallback)->
    window.setLiveChatDisplayCallBack $('.flexible-contact-channels-container #live-chat-container a img'), liveChatDisplayCallback

  flexiblePrimaryLiveChatVisible: ->
    window.liveChatVisible $('.flexible-contact-channels-container #live-chat-container a img')

  handleDisplayOfContactChannels: () ->
    if $('.flex-primary-chat-button#live-chat-container').length > 0
      @handleDisplayOfPrimaryLiveChat()

  toHash: ({withoutChat, renderLayout})->
    hash = {}
    if withoutChat
      hash = @model.get('contactChannelsWithoutBoldChat')
    else if @model.has('formattedContactChannels')
      hash = @model.get('formattedContactChannels')
    else
      hash = @model.get('contactChannelsWithoutBoldChat')

    if renderLayout
      hash = $.extend true, {renderLayout: true}, hash
    hash

  renderLiveChat: ()->
    if @model?.get('liveChatExists')
      if @model.get("primaryChannelIsBoldChat")
        @mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getFlexibleLiveChatType()
        })
      @mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
        startFromSameViewState: @model.get("primaryChannelIsBoldChat")
      })
    else
      @mainView.renderLiveChat({
        liveChatMode: 'static'
      })

module.exports = EmailFormIntlFlexibleContactChannelsView
